<template>
    <sub-page class="add-survey-new">

        <el-form :model="surveyData" class="survey-paper-title" :inline="true" size="small" :rules="titleRules"
                 @submit.native.prevent ref="surveyTitle">
            <el-form-item :label="$t('questionnaire.name') +'：'" prop="name">
                <el-input v-model="surveyData.name" :placeholder="$t('c.name')" clearable></el-input>
            </el-form-item>
            <br/>
            <el-form-item :label="$t('questionnaire.desc')+'：'" label-width="300" prop="description">
                <el-input type="textarea" v-model="surveyData.description"></el-input>
            </el-form-item>
        </el-form>
        <el-col class="exam-panel drag-area" id="dragsort">
            <h2>{{$t('questionnaire.topic')}}</h2>
            <draggable v-model="surveyData.questions"
                       :options="{filter:'.el-input',preventOnFilter:false}">
                <ul v-for="(item, index) in surveyData.questions" style="width: 94%; margin-left: 2%" :key="item.id">
                    <!--单选题-->

                    <el-form :model="item" :rules="titleRules" :inline="true" size="mini" ref="surveyTopic" @submit.native.prevent>
                        <!--单选题-->
                        <li v-if="item.type==2" class="survey-multi single">
                            <div class="topic-title">
                                <el-form-item class="multi-sub-title" :label="(index+1).toString()" label-width="300"
                                              prop="title">
                                    <el-input v-model="item.title" :placeholder="$t('tip.title')" clearable></el-input>
                                </el-form-item>
                            </div>
                            <div v-for="(ele,i) in item.options" style="padding-left: 30px" :key="ele.id">
                                <el-form :inline="true" size="mini" :model="ele" :rules="optionRules" ref="optionRule" @submit.native.prevent>
                                    <el-radio disabled v-model="falseVal" style="margin-right: 10px"></el-radio>
                                    <span style="display: inline-block; width: 13px; text-align: center">{{ele.tag = String.fromCharCode(i+65)}}</span>
                                    <el-form-item prop="title" style="margin-top: 3px">
                                        <el-input v-model="ele.title" :placeholder="$t('tip.option')"
                                                  clearable></el-input>
                                    </el-form-item>
                                    <i v-if="item.options.length>1" class="el-icon-error" style="margin-top: 10px"
                                       @click="deleteOption(item.options, i)"></i>
                                </el-form>
                            </div>
                            <el-button class="add-option" plain size="small" @click="addOption(item.options)">
                                <i class="el-icon-circle-plus-outline"></i>&nbsp;{{$t('survey.addOption')}}
                            </el-button>
                            <i v-if="surveyData.questions.length>1" class="el-icon-error topic"
                               @click="deleteTopic(index)"></i>
                        </li>
                        <!--多选题-->
                        <li v-if="item.type==3" class="survey-multi">
                            <div class="topic-title">
                                <el-form-item class="multi-sub-title" :label="(index+1).toString()" label-width="300"
                                              prop="title">
                                    <el-input v-model="item.title" :placeholder="$t('tip.title')" clearable></el-input>
                                </el-form-item>
                            </div>
                            <div class="topic-count">
                                <label>最多可选</label>：
                                <el-input-number style="margin-top: 2px" v-model="item.limitChoice" :min="1"
                                                 :max="item.options.length"
                                                 :disabled="!item.options.length"
                                                 size="small"
                                ></el-input-number>
                            </div>
                            <div v-for="(ele,i) in item.options" style="padding-left: 30px" :key="ele.id">
                                <el-form :inline="true" size="mini" :model="ele" :rules="optionRules" ref="optionRule" @submit.native.prevent>
                                    <el-checkbox disabled style="margin-right: 10px"></el-checkbox>
                                    <span style="display: inline-block; width: 13px; text-align: center">{{ele.tag = String.fromCharCode(i+65)}}</span>
                                    <el-form-item prop="title" style="margin-top: 3px">
                                        <el-input v-model="ele.title" :placeholder="$t('tip.option')"
                                                  clearable></el-input>
                                    </el-form-item>
                                    <i v-if="item.options.length>1" class="el-icon-error" style="margin-top: 10px"
                                       @click="deleteOption(item.options, i,index)"></i>
                                </el-form>
                            </div>
                            <el-button class="add-option" plain size="small" @click="addOption(item.options)">
                                <i class="el-icon-circle-plus-outline"></i>&nbsp;{{$t('survey.addOption')}}
                            </el-button>
                            <i v-if="surveyData.questions.length>1" class="el-icon-error topic"
                               @click="deleteTopic(index)"></i>
                        </li>
                        <!--评分题-->
                        <li v-if="item.type==1" class="survey-single">
                            <div class="topic-title">
                                <el-form-item class="single-topic" :label="(index+1).toString()" label-width="300"
                                              prop="title">
                                    <el-input v-model="item.title" :placeholder="$t('tip.title')" clearable></el-input>
                                </el-form-item>
                                <div class="survey-single-rate">
                                    <i v-for="i in 5" :key="i" class="el-icon-star-on"></i>
                                </div>
                                <i v-if="surveyData.questions.length>1" class="el-icon-error topic"
                                   @click="deleteTopic(index)"></i>
                            </div>
                        </li>
                        <!--主观题-->
                        <li v-if="item.type==4" class="survey-subjective">
                            <div>
                                <div class="topic-title">
                                    <el-form-item class="multi-sub-title" :label="(index+1).toString()" label-width="300"
                                                  prop="title">
                                        <el-input v-model="item.title" :placeholder="$t('tip.title')" clearable></el-input>
                                    </el-form-item>
                                </div>
                                <div style="padding: 10px 20px 30px 4%; color: #959aa0">
                                    {{$t('tip.input')}}......
                                </div>
                            </div>
                            <i v-if="surveyData.questions.length>1" class="el-icon-error topic"
                               @click="deleteTopic(index)"></i>
                        </li>

                    </el-form>
                </ul>
            </draggable>
            <div class="add-topic">
                <div class="add-topic-control">
                    <i class="el-icon-circle-plus-outline i-show">&nbsp;{{$t('survey.addTitleTip')}}</i>
                    <div class="i-hide">
                        <i class="nucfont inuc-radio-active" @click="addSingle">&nbsp;{{$t('paper.single')}}</i>
                        <i class="nucfont inuc-checkbox-checked" @click="addMulti">&nbsp;{{$t('paper.multiple')}}</i>
                        <i class="nucfont inuc-favor-fill" @click="addScore">&nbsp;{{$t('questionnaire.starTopic')}}</i>
                        <i class="nucfont inuc-zhuguanti" @click="addSubjective">&nbsp;{{$t('survey.subjective')}}</i>
                    </div>
                </div>
            </div>
            <el-button type="primary" size="small"
                       class="survey-submit"
                       @click="addSurveySubmit('surveyTitle','surveyTopic','optionRule')">
                {{$t('c.submit')}}
            </el-button>
        </el-col>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import SubPage from '@/components/Subpage.vue';
    import draggable from 'vuedraggable'

    export default {
        data() {
            return {
                surveyID: this.$route.params.id,

                surveyData: {//调研问卷
                    id: undefined,
                    creatorID: undefined,
                    name: undefined,
                    description: undefined,
                    questions: [//初始时时单选
                        {
                            type: 3,
                            title: undefined,
                            limitChoice:4,
                            options: [
                                {
                                    title: undefined
                                }, {
                                    title: undefined
                                }, {
                                    title: undefined
                                }, {
                                    title: undefined
                                }],
                            order: 1
                        }]
                },
                titleRules: {
                    name: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}
                    ],
                    description: [
                        {max: 300, message: this.$t('rule.maxLength', ['300']), trigger: 'blur'}
                    ],
                    title: [
                        {required: true, message: this.$t('tip.title'), trigger: 'blur'},
                    ]
                },
                optionRules: {
                    title: [
                        {required: true, message: this.$t('tip.option'), trigger: 'blur'},
                    ],
                },
                falseVal:''
            }

        },
        created() {
            this.query()
        },
        computed: {},
        methods: {
            query() {
                let id = this.surveyID;
                if (id) {
                    api.getSurveyNewTemplate(id).then(res => {
                        if (res.package) {
                            for (let ele in this.surveyData) {
                                this.surveyData[ele] = res.package[ele];
                            }
                        }
                    })
                }
            },
            deleteTopic(index) {// 删除题目
                let items = this.surveyData.questions;
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'danger'
                }).then(() => {
                    items.splice(index, 1);
                })
            },
            // 添加题目
            addScore() {
                let items = this.surveyData.questions;
                let addScore = {
                    type: 1,
                    title: undefined,
                    order: items.length+1
                };
                items.push(addScore)
            },
            addMulti() {
                let items = this.surveyData.questions;
                let addMulti = {
                    type: 3,
                    title: undefined,
                    order: items.length+1,
                    limitChoice:4,
                    options: [
                        {
                            title: undefined
                        }, {
                            title: undefined
                        }, {
                            title: undefined
                        }, {
                            title: undefined
                        }],
                };
                items.push(addMulti)
            },
            addSubjective() {
                let items = this.surveyData.questions;
                let addSub = {
                    type: 4,
                    title: undefined,
                    order: items.length+1
                };
                items.push(addSub)
            },
            addSingle() {
                let items = this.surveyData.questions;
                let addSingle = {
                    type: 2,
                    title: undefined,
                    order: items.length+1,
                    options: [
                        {
                            title: undefined
                        }, {
                            title: undefined
                        }, {
                            title: undefined
                        }, {
                            title: undefined
                        }],
                };
                items.push(addSingle)
            },
            deleteOption(options, i,index) {//删除多选题选项
                options.splice(i, 1);
                if(this.surveyData.questions[index].limitChoice>options.length){
                    this.surveyData.questions[index].limitChoice=options.length
                }

            },
            addOption(option) {//添加多选题选项
                if (option.length>25) {
                    this.$message.info('每道多选题最多添加26个选项！');
                } else {
                    let insert = {
                        title: undefined
                    };
                    option.push(insert)
                }
            },
            addSurveySubmit(surveyTitle, surveyTopic, optionRule) {
                let _this = this;
                this.surveyData.questions.forEach((item, index) => {
                    item.order = index+1
                })
                let data = this.surveyData;

                // 初始化标题和多选题选项状态
                let isSubmitTitle = false;
                let isSubmitOption = false;

                // 调研问卷标题判空
                this.$refs[surveyTitle].validate(valid => {
                    if (!valid) return;

                    // 题目标题判空
                    let titles = [];
                    _this.$refs[surveyTopic].forEach(event => {
                        event.validate(valid_1 => {
                            titles.push(valid_1)
                        })
                    });
                    for (let i = 0; i < titles.length; i++) {
                        if (!titles[i]) {
                            isSubmitTitle = false;
                            break
                        }
                        else {
                            isSubmitTitle = true;
                        }
                    }

                    // 多选题选项内容判空
                    let options = [];
                    if (_this.$refs[optionRule]) {
                        _this.$refs[optionRule].forEach(option => {
                            option.validate(valid_2 => {
                                options.push(valid_2)
                            })
                        })
                    }
                    if (options.length > 0) {
                        _this.isSubmitTitle = false;
                        for (let i = 0; i < options.length; i++) {
                            if (!options[i]) {
                                isSubmitOption = false;
                                break
                            }
                            else {
                                isSubmitOption = true;
                            }
                        }
                    } else {
                        isSubmitOption = true;
                    }
                    // 提交
                    if (isSubmitOption && isSubmitTitle) {
                        if (!this.surveyID) {// 添加
                            api.postSurveyNew(data).then(res => {
                                _this.$message.success(this.$t('m.addSuccess'));
                                _this.$router.replace({name: 'surveyNew'});
                                _this.$emit('onClose');
                            })
                        }
                        if (this.surveyID) {// 编辑
                            api.surveyNewUpdate(this.surveyID, data).then(res => {
                                _this.$message.success(this.$t('m.editSuccess'));
                                _this.$router.replace({name: 'surveyNew'});
                                _this.$emit('onClose');
                            })
                        }
                    }
                })
            }
        },
        watch: {},
        components: {
            SubPage,
            draggable
        }
    }
</script>

<style scoped lang="scss">
    /*更改子组件样式*/
    div.ui-card /deep/ div.card-body {
        padding: 20px 0 0;
    }

    .survey-paper-title {
        width: 97%;
        min-width: 1000px;
        margin: auto;
        @media screen and (max-width: 1280px) {
            min-width: 0;
        }
    }

    .survey-paper-title /deep/ .el-form-item--small {
        width: 100%;
        .el-form-item__label {
            width: 100px;
            text-align: right;
        }
        .el-form-item__content {
            width: 90%;
        }
    }

    .exam-panel {
        h2 {
            width: 97%;
            padding: 5px 15px;
            margin: 20px auto;
            font-size: 16px;
            border-bottom: 1px dashed #cbcbcb;
        }
        .survey-single,
        .survey-multi,
        .survey-subjective {
            border: 1px solid #ebebeb;
            margin: 5px 5px 20px;
            position: relative;
        }
        .survey-single:hover,
        .survey-multi:hover,
        .survey-subjective:hover {
            box-shadow: 0 0 5px rgba(65, 190, 255, 0.48);
            border-color: rgba(60, 193, 255, 0.65);
        }
        .topic-title { //题目标题
            position: relative;
            margin: 0 0 10px;
            padding: 10px 30px 10px 15px;
            background: #fafafc;
            div {
                margin: 0;
            }
        }
        .el-icon-error {
            color: #999;
        }
        .el-icon-error.topic {
            font-size: 16px;
            position: absolute;
            right: -25px;
            top: 15px;
        }
        .el-icon-error:hover {
            cursor: pointer;
            color: #22b9ff;
        }
        /*单选标题*/
        .survey-single {
            .topic-title {
                margin: 0;
                display: flex;
                .single-topic {
                    width: 80%;
                    display: flex;
                }
                .single-topic /deep/ .el-form-item__label {
                    width: 5%;
                }
                .single-topic /deep/ .el-form-item__content {
                    flex: 1;
                }
                .survey-single-rate {
                    flex: 1;
                    text-align: right;
                    display: inline-block;
                    font-size: 25px;
                    color: #cdcdcd;
                    @media screen and (max-width: 1280px) {
                        font-size: 20px;
                    }
                    i {
                        margin-left: 5px;
                    }
                }
            }
        }
        /*多选 + 主观题标题*/
        .survey-multi,
        .survey-subjective {
            .topic-title {
                .multi-sub-title {
                    width: 100%;
                    display: flex;
                }
                .multi-sub-title /deep/ .el-form-item__label {
                    width: 4%;
                }
                .multi-sub-title /deep/ .el-form-item__content {
                    flex: 1;
                }
            }
        }
        /*多选选项*/
        .survey-multi {
            .el-form-item--mini {
                width: 50%;
            }
            .el-form-item--mini /deep/ .el-form-item__content {
                width: 100%;
            }
            .add-option {
                width: 100%;
                border: 1px dashed #307faa;
                margin-top: 20px;
                font-size: 16px;
                color: #307faa;
            }
            .topic-count{
                display: flex;
                line-height: 36px;
                margin-left: 30px;
                margin-bottom: 20px;
            }
        }
        .add-topic {
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px dashed #307faa;
            font-size: 16px;
            color: #307faa;
            width: 94%;
            margin: 50px 0 50px 2%;
            .i-hide {
                display: none;
                i {
                    margin: 0 10px;
                }
                i:hover {
                    color: #22b9ff;
                }
            }
            div.add-topic-control:hover {
                cursor: pointer;
                .i-show {
                    display: none;
                }
                .i-hide {
                    display: block;
                }
            }
        }
        .add-topic:hover {
            background: #f2fbff;
        }
        .survey-submit {
            margin: 0 0 60px 50%;
            transform: translateX(-100px);
            width: 200px;
            border-radius: 20px;
            font-size: 16px;
        }
        .section-content {
            cursor: move;
        }
    }
</style>
<style lang="scss">
    .add-survey-new{
        .el-radio__inner{
            width: 18px;
            height: 18px;
            &::after {
                width: 5px;
                height: 10px;
                top: 1px;
                left: 5px;
            }
        }
        .el-radio__label{
            padding-left: 0;
        }
        .el-radio__input.is-disabled .el-radio__inner {
            background-color: #edf2fc;
            border-color: #DCDFE6;
            cursor: not-allowed;
        }
    }
</style>
